import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { screenerSelectors } from 'features/screener/slice';

import { emptyObject } from 'utils/general';
import ScreenerForm from './ScreenerForm/index';
import ScreenerLabel from './ScreenerMain/ScreenerLabel';
import ScreenerPagination from './ScreenerMain/ScreenerResult/ScreenerPagination';
import ScreenerTable from './ScreenerMain/ScreenerResult/ScreenerTable';
import {
  SContainerScreenerBody,
  ScreenerLoadingOverlay,
  SContainerScreenerTable,
  SContainerScreener,
  SContainerScreenerPagination,
  ScreenerResultEmpty,
} from './styled';

const Body = () => {
  const {
    screenerUtils: {
      isFormActive,
      isFormEditMode,
      isFormCreateMode,
      screenerAction,
      isEmptyResult,
    },
    screenerResult: { data: dataScreenerResult, isLoading: isLoadingResult },
    screenerPostResult: { data: dataScreenerPostResult, isLoading: isLoadingPostResult },
  } = useSelector(screenerSelectors);

  const isLoading = isLoadingResult || isLoadingPostResult;
  const isDataEmpty = !emptyObject(dataScreenerResult) || !emptyObject(dataScreenerPostResult);

  const showScreenerLabel = !isFormCreateMode && !isFormActive && isDataEmpty;

  const isEmpty = useMemo(() => {
    if (screenerAction === 'get') {
      if (dataScreenerResult?.calcs?.length === 0) {
        return true;
      }
      if (emptyObject(dataScreenerResult) && isFormCreateMode) {
        return true;
      }
      return false;
    }

    if (screenerAction === 'post') {
      if (dataScreenerPostResult?.calcs?.length === 0) {
        return true;
      }
      if (emptyObject(dataScreenerPostResult) && isFormCreateMode) {
        return true;
      }
      return false;
    }

    if (isEmptyResult && isFormCreateMode) {
      return true;
    }

    return false;
  }, [isEmptyResult, screenerAction, dataScreenerResult, dataScreenerPostResult, isFormCreateMode]);

  const showResult = !isEmpty && screenerAction !== null;

  return (
    <>
      {isFormActive && (
        <SContainerScreenerBody>
          <ScreenerForm />
        </SContainerScreenerBody>
      )}
      <SContainerScreener>
        <ScreenerLoadingOverlay isLoading={isLoading} />
        {showScreenerLabel && <ScreenerLabel data={dataScreenerResult} />}
        {showResult && (
          <>
            <SContainerScreenerPagination
              isFormActive={isFormCreateMode || isFormEditMode || isFormActive}
            >
              <ScreenerPagination />
            </SContainerScreenerPagination>
            <SContainerScreenerTable>
              <ScreenerTable />
            </SContainerScreenerTable>
          </>
        )}
        {(isEmpty && !isLoading) && (
          <ScreenerResultEmpty>
            <p>No Result for this rule</p>
          </ScreenerResultEmpty>
        )}
      </SContainerScreener>
    </>
  );
};

export default Body;
